// extracted by mini-css-extract-plugin
export var isRaised = "shadow-module--isRaised--lo-E1";
export var shadow = "shadow-module--shadow--whX8a";